import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { FilesService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-delete-file',
  templateUrl: './delete-file.component.html',
  styleUrls: ['./delete-file.component.css']
})
export class DeleteFileComponent implements OnInit {

  @Input() set data(value) {

    if (value != null) {

      this.fileId = value.id;
    }
  }

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  fileId: string;
  deleteFileInfo: any[] = [];

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private apiFileService: FilesService,
    private notification: NotificationService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.fileInfo();
  }


  /**
   * 
   */
  fileInfo() {

    let data = {
      id: this.fileId,
      mandatory: false
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.deleteMapping(data).subscribe(response => {
        console.log('[RESPONSE] fileInfo: ', response);

        if (response != null) {

          this.deleteFileInfo = response.result;
        }

        this.progressRef.complete();
      })
    );
  }


  onConfirmDelete() {
    let data = {
      id: this.fileId,
      mandatory: true
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.deleteMapping(data).subscribe(response => {
        console.log('[RESPONSE] fileInfo: ', response);

        // if (response != null) {

        this.notification.show('success', 'Файл(ы) успешно удален(ы)!');
        this.activeModal.close(true);
        // }

        this.progressRef.complete();
      })
    );

  }


  /**
   * 
   * @returns 
   */
  checkPermission(): boolean {

    if (this.deleteFileInfo.length > 0) {

      return this.deleteFileInfo.find(val => val.count > 0) ? true : false;
    }
  }

}
